import { useMemo } from 'react';
import { useCatalogInfo, useRestApi } from 'app/common/hooks';

/**
 * Hook to fetch category brand fields from the catalog service.
 *
 * @param {string} categoryId The ID of the category
 * @param {string} brandId The ID of the brand
 * @returns {RestApiState} The fetch response
 */
const useCategoryBrandFieldsApi = (categoryId, brandId) => {
  const { categoryBrandFieldsInfo } = useCatalogInfo();
  const url = `${categoryBrandFieldsInfo.fetchContextPath}`;

  const config = useMemo(
    () => ({
      params: {
        categoryId,
        brandId,
        storefront: true
      }
    }),
    [categoryId, brandId]
  );

  return useRestApi(url, config, !!(categoryId && brandId));
};

export default useCategoryBrandFieldsApi;
